interface TokenValuesResult {
  primaryColor: string;
  secondaryColor: string;
  background: string;
}

export function getValuesFromTokens(tokens?: Record<string, string>): TokenValuesResult | undefined {
  if (!tokens) {
    return;
  }

  const primaryColor = tokens['--primary-fill-default'];
  const secondaryColor = tokens['--secondary-fill-default'];
  const background = tokens['--top-nav-surface'];

  if (primaryColor && secondaryColor && background) {
    return {
      primaryColor,
      secondaryColor,
      background,
    };
  }

  return;
}
